import { FeatureEnabledV2, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { TRANSACTIONS_NAMESPACE } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { namespace } from 'vuex-class';
import { CoreXOperationType, CoreXTransacationStatus } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';

// magic-corex-summed-transaction-totals
var transactions = namespace(TRANSACTIONS_NAMESPACE);
var HistoryType;
(function (HistoryType) {
    HistoryType["GAMING"] = "gaming";
    HistoryType["PAYMENTS"] = "payments";
})(HistoryType || (HistoryType = {}));
/**
 * Component that shows summed totals for the ranges
 * given depending on the history type.
 */
var SummedTransactionTotalsComponent = /** @class */ (function (_super) {
    __extends(SummedTransactionTotalsComponent, _super);
    function SummedTransactionTotalsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sportsbookHistoryEnabled = false;
        _this.totalWon = 0;
        _this.totalBet = 0;
        _this.totalDeposits = 0;
        _this.totalWithdrawals = 0;
        _this.netAmount = 0;
        return _this;
    }
    SummedTransactionTotalsComponent.prototype.created = function () {
        this.fetchData();
    };
    SummedTransactionTotalsComponent.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.from || !this.to || this.isLoading) {
                    return [2 /*return*/];
                }
                try {
                    this.onContentLoadInit();
                    this.calculateSummaryOfTransactions();
                    this.onContentLoad(this.transactions);
                }
                catch (e) {
                    this.onContentLoadError(e);
                }
                return [2 /*return*/];
            });
        });
    };
    SummedTransactionTotalsComponent.prototype.calculateSummaryOfTransactions = function () {
        var _this = this;
        var _a, _b;
        this.resetData();
        var allTransactions = this.sportsbookHistoryEnabled && ((_a = this.sportsTransactions) === null || _a === void 0 ? void 0 : _a.length)
            ? (this.transactions || []).concat(this.sportsTransactions || [])
            : this.transactions;
        if (!allTransactions) {
            return;
        }
        if (this.sportsbookHistoryEnabled && ((_b = this.sportsTransactions) === null || _b === void 0 ? void 0 : _b.length)) {
            allTransactions = allTransactions
                .sort(function (a, b) {
                return new Date(b.Timestamp).getTime() -
                    new Date(a.Timestamp).getTime();
            })
                .slice(0, this.displaySize);
        }
        allTransactions
            .filter(function (transaction) {
            return !_this.currency ||
                transaction.Payload.CurrencyCode === _this.currency;
        })
            .forEach(function (transaction) {
            var isCredit = transaction.Payload.OperationType ===
                CoreXOperationType.CREDIT;
            var amount = transaction.Payload.Amount;
            var isCompleted = transaction.Payload.Transaction.Current.Status ===
                CoreXTransacationStatus.COMPLETED;
            if (isCompleted) {
                if (_this.historyType === HistoryType.GAMING) {
                    if (isCredit) {
                        _this.totalWon += amount;
                    }
                    else {
                        _this.totalBet += amount;
                    }
                    _this.netAmount = _this.totalWon - _this.totalBet;
                }
                else {
                    if (isCredit) {
                        _this.totalDeposits += amount;
                    }
                    else {
                        _this.totalWithdrawals += amount;
                    }
                    _this.netAmount =
                        _this.totalDeposits - _this.totalWithdrawals;
                }
            }
        });
    };
    SummedTransactionTotalsComponent.prototype.resetData = function () {
        if (this.historyType === HistoryType.PAYMENTS) {
            this.netAmount = 0;
            this.totalDeposits = 0;
            this.totalWithdrawals = 0;
            this.totalBet = undefined;
            this.totalWon = undefined;
        }
        else {
            this.netAmount = 0;
            this.totalBet = 0;
            this.totalWon = 0;
            this.totalDeposits = undefined;
            this.totalWithdrawals = undefined;
        }
    };
    __decorate([
        Prop({
            type: String,
            default: HistoryType.PAYMENTS,
        }),
        __metadata("design:type", String)
    ], SummedTransactionTotalsComponent.prototype, "historyType", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", Object)
    ], SummedTransactionTotalsComponent.prototype, "currency", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], SummedTransactionTotalsComponent.prototype, "from", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], SummedTransactionTotalsComponent.prototype, "to", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SPORTSBOOK_HISTORY,
        }),
        __metadata("design:type", Boolean)
    ], SummedTransactionTotalsComponent.prototype, "sportsbookHistoryEnabled", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], SummedTransactionTotalsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('getTransactions'),
        __metadata("design:type", void 0)
    ], SummedTransactionTotalsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Getter('getSportsTransactions'),
        __metadata("design:type", void 0)
    ], SummedTransactionTotalsComponent.prototype, "sportsTransactions", void 0);
    __decorate([
        transactions.Getter('getDisplaySize'),
        __metadata("design:type", void 0)
    ], SummedTransactionTotalsComponent.prototype, "displaySize", void 0);
    __decorate([
        Watch('transactions'),
        Watch('sportsTransactions'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SummedTransactionTotalsComponent.prototype, "fetchData", null);
    SummedTransactionTotalsComponent = __decorate([
        Component({
            name: 'corex-summed-transaction-totals',
            store: store,
        })
    ], SummedTransactionTotalsComponent);
    return SummedTransactionTotalsComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default SummedTransactionTotalsComponent;
export { HistoryType };
